import { ReviewTemplateFormProps } from './Types'
import { ReviewTemplateForm } from './ReviewTemplateForm/ReviewTemplateForm'

import { Modal } from 'almanac-ui/Modal'
import { useRef } from 'react'

export const NewReviewTemplateFormModal = (formProps: ReviewTemplateFormProps) => {
  const footer = useRef<HTMLDivElement>(null)
  return (
    <Modal.Root size="md">
      <Modal.Top>
        <Modal.BackButton />
      </Modal.Top>
      <Modal.Header title={formProps.initialTemplate?.name ?? 'Save as New Request Template'} />
      <Modal.Content>
        <ReviewTemplateForm {...formProps} footerPortal={footer} />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <div ref={footer} />
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
